import { COOKIE_DOMAIN, PROFILE_TYPES, USE_MOCK_DATA } from '@/api/config'
import User from '@/classes/auth/User'

const Cookies = require('js-cookie')

export default class AuthUser extends User {
  constructor () {
    super()
    this.setAuthUserFromCookie()
  }

  setAuthUserFromCookie () {
    let json = {}
    try {
      json = JSON.parse(Cookies.get('AuthUser'))
    } catch (err) {
      json = {}
    }
    this.setUser(json)
  }

  hasProfile (profile) {
    return !!this.profiles.find(p => {
      return p.id === profile.profileId && p.profileType === profile.profileType
    })
  }

  loginAuthUser (json) {
    Cookies.set('AuthUser', JSON.stringify(json))
    this.setAuthUserFromCookie()
  }

  logoutAuthUser () {
    Cookies.remove('AuthUser')
    this.setAuthUserFromCookie()
  }

  isSwitchedProfile () {
    return this.id !== this.profile.userId
  }

  isSwitchedWithConnectedProfile () {
    return this.isSwitchedProfile &&
      this.profiles.find(profile => profile.userId === this.profile.userId)
  }

  isAuditor () {
    return this.profile.profileType === PROFILE_TYPES.AUDITOR
  }

  isAdministrator () {
    return this.profile.profileType === PROFILE_TYPES.ADMINISTRATOR
  }

  isManager () {
    return this.profile.profileType === PROFILE_TYPES.MANAGER
  }

  isHR () {
    return this.profile.profileType === PROFILE_TYPES.HR
  }

  isCustomer () {
    return this.profile.profileType === PROFILE_TYPES.CUSTOMER
  }

  static isLoggedIn () {
    if (!USE_MOCK_DATA) {
      return !!Cookies.get('idun-csrf') && !!Cookies.get('AuthUser')
    } else {
      return !!Cookies.get('AuthUser')
    }
  }

  static setLanguage (code = 'sv') {
    let attributes = {}
    if (COOKIE_DOMAIN) {
      attributes['domain'] = COOKIE_DOMAIN
    }
    Cookies.set('idun-language', code, attributes)
  }

  static getLanguage () {
    return Cookies.get('idun-language')
  }

  static isMainProfile (profile) {
    return profile.userId === this.id
  }

  static getProfileType () {
    let authUser = new AuthUser()
    return authUser.profile.profileType
  }

  static isAdministrator (profileType) {
    if (profileType) {
      return profileType === PROFILE_TYPES.ADMINISTRATOR
    } else {
      return AuthUser.getProfileType() === PROFILE_TYPES.ADMINISTRATOR
    }
  }

  static isAuditor (profileType) {
    if (profileType) {
      return profileType === PROFILE_TYPES.AUDITOR
    } else {
      return AuthUser.getProfileType() === PROFILE_TYPES.AUDITOR
    }
  }

  static isCustomer (profileType) {
    if (profileType) {
      return profileType === PROFILE_TYPES.CUSTOMER
    } else {
      return AuthUser.getProfileType() === PROFILE_TYPES.CUSTOMER
    }
  }

  static isManager (profileType) {
    if (profileType) {
      return profileType === PROFILE_TYPES.MANAGER
    } else {
      return AuthUser.getProfileType() === PROFILE_TYPES.MANAGER
    }
  }

  static isHR (profileType) {
    if (profileType) {
      return profileType === PROFILE_TYPES.HR
    } else {
      return AuthUser.getProfileType() === PROFILE_TYPES.HR
    }
  }

  static getProfileTypeVerbose (profileType) {
    if (AuthUser.isAdministrator(profileType)) {
      return 'Administrator'
    } else if (AuthUser.isAuditor(profileType)) {
      return 'Auditor'
    } else if (AuthUser.isCustomer(profileType)) {
      return 'Customer'
    } else if (AuthUser.isHR(profileType)) {
      return 'Human resources'
    }

    return ''
  }
}
